"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_router_1 = require("react-router");
var root_route_1 = require("./root_route");
exports.default = (function (routes) { return ([
    React.createElement(react_router_1.Route, { key: "root", path: "/", component: root_route_1.default }, routes),
    React.createElement(react_router_1.Route, { key: "region-root", path: "/:region", component: root_route_1.default }, routes),
]); });
//# sourceMappingURL=build_root_routes.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/reverb-js-common/build_root_routes.js
// module id = a3ap
// module chunks = 20 21